import "./PredictorTools.scss";
import CustomNavigation from "./CustomNavigation";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";

// Optional utility function (unused in this component currently)
const payloadFormatter = (data: any) => {
  if (!data || typeof data !== "object") return [];
  return Object.keys(data).map((key, index) => ({
    title: key,
    id: index,
  }));
};

const PredictorTools = () => {
  const knowledgeHub: any = useSelector(
    (state: RootState) => state?.predictorLanding?.knowledgrHub
  );

  // Extract categories with fallback
  const streams = knowledgeHub?.categories ?? [];

  if (!Array.isArray(streams) || streams.length === 0) {
    return null;
  }

  return (
    <div className="w-full flex bg-[#E2F3FF] relative mb-7">
      <div className="container overflow-hidden">
        <div className="heading-tools py-4 lg:px-36">
          Discover your Ideal Exam & Course with our Advanced College Predictor
          and Rank Predictor Tools
        </div>
        <CustomNavigation tabs={streams} data={knowledgeHub} />
      </div>
    </div>
  );
};

export default PredictorTools;
